import { throwError } from "@/lib/throwError";
import { get, post } from "@/services/axiosUitils";
import {
  RecordWorkflowStatus,
  WorkflowActionPayload,
  WorkflowActionResponse,
} from "@/utils/types/workflowRecord";

const basePath = "/workflow";

class WorkflowRecordService {
  getRecordWorkflowStatus = async (
    schemaName: string,
    recordId: string
  ): Promise<RecordWorkflowStatus> => {
    if (!schemaName || !recordId) {
      throwError(
        "Schema name and record ID are required",
        "WorkflowRecordService"
      );
    }
    return await get(`${basePath}/status/`, {
      params: {
        schema_name: schemaName,
        record_id: recordId,
      },
    });
  };

  performWorkflowAction = async (
    payload: WorkflowActionPayload
  ): Promise<WorkflowActionResponse> => {
    if (!payload) {
      throwError("Payload is required", "WorkflowRecordService");
    }
    return await post(`${basePath}/onAction/`, payload);
  };
}

export default new WorkflowRecordService();
